import NavbarLogin from "../../../components/nav/nav_login";
import TermsOfServiceContent from "../../term_of_service_content";
import "./term_page.css";
import { useNavigate } from "react-router-dom";

const TermsPage =  () =>{

    const navigate = useNavigate();

    const navigateToTerms = () => {
        navigate("/terms_of_service");
    }

    const navigateToHome = () =>{
        navigate("/");
    }

    const navigateToPrivacy = () =>{
        navigate("/privacy_policy");
    }

    return(
        <div className="legal-page-whole-outer" style={{width:'100%'}}>
            <div className="legal-page-whole">
                <NavbarLogin/>
                <TermsOfServiceContent></TermsOfServiceContent>
            </div>
            {<div className="footer-container">
                    <p onClick={navigateToHome} className="footer-brand">Stock Archives LLC</p>
                    <p onClick={navigateToTerms}  className="footer-other-right">Terms Of Use</p>
                    <p onClick={navigateToPrivacy} className="footer-other-left">Privacy Policy</p>
            </div>}
        </div>
    );
}

export default TermsPage;